import { Draft } from "../Draft.model";

export function parseDraft(raw: any): Draft {
    if (!raw) return raw;
    return {
        ...raw.draftInfo,
        rows: raw.rows,
        meta: raw.meta,
    };
}
